import createCore from "@slks/core";
export default createCore();
